import React, { Component } from 'react'; 
import classes from './SlidingSwitch.scss';

class SlidingSwitch extends Component {
    render() {
        return (
            <label className={classes.Switch}>
                <input {...this.props} type="checkbox"/>
                <span className={classes.Slider}></span>
            </label>
        );
    }
}

export default SlidingSwitch;


// WEBPACK FOOTER //
// ./src/components/UI/SlidingSwitch/SlidingSwitch.js